module.exports = __webpack_public_path__ + "media/application/images/ui/mostpopular_banner-4f3a4d17ef1242b26b8dc6b1c34abf22.png";